import React, { useState } from 'react';
import styled from 'styled-components';
import { testId } from '@lojinha/helpers';
import { Chevron } from '../Icons/chevron';
import { Box } from '../Box';
import { tabNavigationStyle } from '../../helpers/tabNavigationStyle';
const Icon = styled.div `
  height: 1rem;
  width: 1rem;
  margin-left: auto;
  transition: transform 0.2s ease-in-out;
  transform: rotate(${({ show }) => (show ? '180deg' : '0deg')});
  display: ${({ hideChevron }) => (hideChevron ? 'none' : 'block')};
`;
const HeadingIcon = styled.div(({ theme }) => `
  margin-right: 1rem;
  align-self: flex-start;
  ${theme.media.above('sm')} {
    margin-right: 1.5rem;
  }
  `);
const Button = styled.button `
  ${tabNavigationStyle}
  width: 100%;
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: center;
  align-self: flex-start;
  background: none;
  border: 0;
  display: flex;
  cursor: ${({ isCursorDefault }) => (isCursorDefault ? 'default' : 'pointer')};
  font-size: ${({ headingSize, theme }) => headingSize || theme.fontSizes.x2};
  font-weight: ${({ theme, isBold }) => isBold ? theme.fontWeights.bold : theme.fontWeights.normal};
  line-height: ${({ theme }) => theme.lineHeights.x2};
  padding: 0;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme, isBrand }) => (isBrand ? theme.fonts.brand : '')};
  text-align: left;
`;
export const Accordion = ({ children, heading, headingIcon, headingSize, isOpenByDefault, handleChange, open, hideChevron, isBold, isBrand, isCursorDefault, justifyContent, htmlAttrs, }) => {
    const type = typeof open === 'boolean' ? 'uncontrolled' : 'controlled';
    const [show, setShow] = useState(isOpenByDefault);
    const isOpen = type === 'uncontrolled' ? open : show;
    const idForA11y = heading.replace(/\s/g, '-');
    return (React.createElement(Box, { htmlAttrs: htmlAttrs },
        React.createElement(Button, { "aria-controls": idForA11y, "aria-expanded": isOpen, isBold: isBold, isBrand: isBrand, justifyContent: justifyContent, isCursorDefault: isCursorDefault, headingSize: headingSize, onClick: () => {
                handleChange && handleChange(!isOpen);
                if (type === 'controlled') {
                    setShow(!isOpen);
                }
            }, ...testId('accordion-arrow-button') },
            headingIcon && React.createElement(HeadingIcon, null, headingIcon),
            heading,
            React.createElement(Icon, { "align-self": "center", "aria-hidden": true, show: isOpen, hideChevron: hideChevron },
                React.createElement(Chevron, { color: "success" }))),
        React.createElement("div", { "aria-hidden": !show, id: idForA11y, style: { display: isOpen ? 'block' : 'none' } }, children)));
};
Accordion.defaultProps = {
    justifyContent: 'flex-start',
};
//# sourceMappingURL=index.js.map